import { Container, Dialog, DialogContent, IconButton } from '@material-ui/core'
import Backdrop from '@material-ui/core/Backdrop'
import RefreshIcon from '@material-ui/icons/Refresh';
import CircularProgress from '@material-ui/core/CircularProgress'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import MUIDataTable from "mui-datatables"
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router-dom'
import { DialogTitle, PaperComponent } from '../../../components/ui/AlertDialog'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import MvmApi from '../../../services/MvmApi'
import { DataFormat, MinutesToHHMMFormat } from '../../../utils/componentUtils'
import utilsDate from '../../../utils/Date'
import permissions from '../../../utils/Permissions'
import MvmShedList from '../../Concierge/Manage/MvmShedList'
import { useStyles } from './Style'

const VehicleStayTimeMonitor: React.FC = () => {
    const history = useHistory();
    const classes = useStyles();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("Mvm");
    const { user, hasPermission } = useAuth();
    const [openBackdrop] = React.useState(false);
    const [selectedMvm, setSelectedMvm] = React.useState<any>(null);
    const [isShedModalOpen, setIsShedModalOpen] = React.useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = React.useState<number | null>(null);
    const { control, setValue } = useForm<any>(
        {
            defaultValues: {
                sheds: [],
            }
        })

    const { isLoading, isFetching, data, refetch } = useQuery('getVehicleStayTime', async () => {
        console.log("getVehicleStayTime", new Date().toLocaleTimeString());
        return await MvmApi.getVehicleStayTimeMonitor(+user.company.plantID);
    }, {
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        staleTime: 1000 * 360, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 300, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        refetch()
    }, [])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!hasPermission(permissions.MVM.VehicleStayTime)) {
            history.replace('NoPermission');
        }
    }, [history, user])

    const columns = [
        {
            name: 'mvmCode',
            label: t("mvmNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                // customBodyRender: (value : any, tableMeta : any, updateValue : any) => (
                //     <Link href="#" onClick={() => startPendingTransportOrder(value)}>{value}</Link>
                // )
            }

        },
        {
            name: 'vehiclePlateNumber',
            label: _t("plate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'supplierDescription',
            label: t("shippingCompanySupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'entranceDate',
            label: t("entranceDate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: DataFormat
            }
        },
        {
            name: 'qtyPoints',
            label: t("localQuantity"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'permanence',
            label: t("permanence"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number) => ({
                    align: "center",
                    style: Colorir(rowIndex, "flagStayStatus")
                }),
                customBodyRender: MinutesToHHMMFormat
            }
        },
        {
            name: 'inactivityMinutes',
            label: t("inactivityTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number) => ({
                    align: "center",
                    style: Colorir(rowIndex, "flagMinutesStatus")
                }),
                customBodyRender: MinutesToHHMMFormat
            }
        }
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: _t('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: _t("next"),
                previous: _t("previous"),
                rowsPerPage: _t("rowsPerPage") + ":",
                displayRows: _t("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                },

            },
            MuiTableRow: {
                root: { '&$selected, &$selected:hover': { backgroundColor: '#d9e6f3', } }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    function Colorir(rowIndex: any, propertieName: string) {

        var color = data![rowIndex][propertieName];

        return {
            backgroundColor: color,
            color: color !== "YELLOW" ? "white" : "black"
        }
    }

    const handleCloseShedModal = () => {
        setIsShedModalOpen(false);
        setSelectedMvm(null);
        setSelectedRowIndex(null);
        setValue('sheds', []);
    }

    const onSelect = async (currentRowsSelected: any, allRowsSelected: any, rowsSelected: any) => {
        const selectedIndex = allRowsSelected.length > 0
            ? allRowsSelected[allRowsSelected.length - 1].index
            : undefined;

        if (selectedIndex === undefined || !data?.[selectedIndex]) {
            return;
        }

        setSelectedRowIndex(selectedIndex);
        setSelectedMvm(data[selectedIndex]);

        const shedList = await MvmApi.getShedListById(data[selectedIndex].mvmId);

        setValue('sheds', shedList);
        setIsShedModalOpen(true);

    }

    return (
        <Container maxWidth={false} component="main" style={{ paddingBottom: 10 }}>
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <PageTitle title={t("vehiclePermanenceTimeTitle")} />

            <div style={{ marginTop: "0.2rem", marginBottom: "0.3rem", display: "grid" }}>
                <span style={{ fontWeight: "bold", fontSize: "0.8rem" }}> {_t("lastUpdate") + utilsDate.TimeByCompleteDate(new Date())}
                    <IconButton onClick={() => refetch()}>
                        <RefreshIcon style={{ color: '#597dda' }} />
                    </IconButton>
                </span>
                <span>{_t("totalRecords") + (data ? data.length : 0)}</span>
            </div>
            {
                <MuiThemeProvider theme={myTheme}>
                    <MUIDataTable
                        title=""
                        data={data != null && data.length > 0 ? data : []}
                        columns={columns}
                        options={{
                            ...options,
                            serverSide: true,
                            pagination: false,
                            sort: false,
                            selectToolbarPlacement: "none",
                            filter: false,
                            search: false,
                            download: false,
                            print: false,
                            viewColumns: false,
                            selectableRows: 'single',
                            selectableRowsOnClick: true,
                            rowsSelected: selectedRowIndex !== null ? [selectedRowIndex] : [],
                            onRowSelectionChange: onSelect,
                            selectableRowsHideCheckboxes: true,
                            selectableRowsHeader: false,
                        }}
                    />

                    <Dialog
                        open={isShedModalOpen}
                        aria-labelledby="vehicle-stay-time-shed-dialog-title"
                        PaperComponent={PaperComponent}
                        fullWidth
                        maxWidth="lg"
                        disableBackdropClick
                        disableEscapeKeyDown
                    >
                        <DialogTitle
                            id="draggable-dialog-title"
                            onClose={handleCloseShedModal}
                        /> 
                        <DialogContent>
                            <MvmShedList
                                control={control}
                                name={"sheds"}
                                resumido={false}
                                mvmNumber={selectedMvm?.mvmCode}
                            />
                        </DialogContent>
                    </Dialog>
                </MuiThemeProvider>
            }
        </Container>
    )
}
export default VehicleStayTimeMonitor;


